import AuthContext from 'context/AuthContext'
import { useContext, useEffect } from 'react'
import { generateRandomID } from 'utils/reusableMethods'

const LoginWithSmartfinCallback = () => {
  let { loginWithSmartfin } = useContext(AuthContext)

  const callApi = async () => {
    var params = new URLSearchParams(window.location.search)
    await loginWithSmartfin(
      {
        deviceID: generateRandomID(10),
        deviceType: "web",
        deviceToken: generateRandomID(20),
        token: params.get("token")
      }
    )
  }

  useEffect(() => {
    callApi()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="w-full flex text-center justify-center h-full">
      <img src="images/whitelogo.svg" className="w-[20rem] md:w-[15rem] shimmerable shimmer-loading hidden dark:block" alt="ALPAY LOGO" />
      <img src="images/logo.svg" className="w-[20rem] md:w-[15rem] shimmerable shimmer-loading block dark:hidden" alt="ALPAY LOGO" />
    </div>
  );
}

export default LoginWithSmartfinCallback
